import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import EmailUpdateForm from './EmailUpdateForm';

const AccountEmailUpdateModal = () => {
  const state = useAccountState();
  const { closeEmailUpdateModal } = useAccountActions();

  return (
    <StandardModal
      isOpen={state?.emailUpdateModalIsOpen}
      contentLabel="Update Email"
      onRequestClose={() => {
        closeEmailUpdateModal();
      }}
    >
      <EmailUpdateForm />
    </StandardModal>
  );
};

export default AccountEmailUpdateModal;